/**
 * nodeSettingsAtom.ts
 * 設定ダイアログを開いているカードのIDを共有する Jotai atom
 * カード側の設定ボタンが書き込み、FlowEditor が読み取ってダイアログを描画する
 */
import { atom } from 'jotai';

/** 設定ダイアログを開いているカードのID（閉じているときは null） */
export const nodeSettingsNodeIdAtom = atom<string | null>(null);
